/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthOtpResponseBaseResponse as ModelsAuthenticationAuthOtpResponseBaseResponse } from '../../models/Models/Authentication/auth-otp-response-base-response';

export interface V3PublicApplicationStartOtpGet$Plain$Params {
  nonce?: string;
  mobile?: string;
  email?: string;
}

export function v3PublicApplicationStartOtpGet$Plain(http: HttpClient, rootUrl: string, params?: V3PublicApplicationStartOtpGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationStartOtpGet$Plain.PATH, 'get');
  if (params) {
    rb.query('nonce', params.nonce, {});
    rb.query('mobile', params.mobile, {});
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>;
    })
  );
}

v3PublicApplicationStartOtpGet$Plain.PATH = '/v3/public/application/start-otp';
